<template>
  <b-sidebar
    id="sidebar-send-invoice"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">
          Reject Refund
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <b-form-group label="Remark" label-for="Remark">
          <b-form-textarea
            v-model="formData.remark"
            placeholder="Add remark"
            rows="5"
            trim
            required
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mr-3"
            @click="hide"
          >
            Cancel
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="danger"
            type="submit"
            @click="submitRejectRequest"
          >
            Reject
          </b-button>
        </div>
      </b-form>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    BSidebar,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
  },
  directives: {
    Ripple,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ["info"],
  data() {
    return {
      isLoading: false,
      amount: this.info.refundRequestedAmount,
      formData: {
        RefundRequestId: this.info.id,
        action: 2,
        remark: "",
      },
    };
  },
  computed: {
    getInfo() {
      return this.info; // props value
    },
  },
  methods: {
    submitRejectRequest() {
      this.isLoading = true;
      axios
        .post("/Order/api/V1.0/Refund/RefundWorkflowAction", this.formData)
        .then(() => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "success",
              icon: "BellIcon",
              variant: "success",
              text: `Refund Rejected`,
            },
          });
          this.$router.push({ name: "refunds-history" });
        })
        .catch((err) => {
          this.isLoading = false;
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              icon: "BellIcon",
              variant: "danger",
              text: `${err.data.message}`,
            },
          });
          // this.$refs.loginForm.setErrors(error)
        });
    },
  },
};
</script>

<style></style>
